/*
Create a tenant provider that will provide the tenant to the app.
*/

import React from "react";
import type { RootLoaderData } from "~/root";

export namespace TenantContext {
  export type Tenant = RootLoaderData["tenant"];
}

const TenantContext = React.createContext<TenantContext.Tenant>({} as TenantContext.Tenant);

export namespace TenantProvider {
  export type Props = {
    children: React.ReactNode;
    value: TenantContext.Tenant;
  };
}

export function TenantProvider({ children, value }: TenantProvider.Props) {
  return <TenantContext.Provider value={value}>{children}</TenantContext.Provider>;
}

export function useTenant() {
  return React.useContext(TenantContext);
}
